<div class="successPayment" role="main" aria-label="Payment success page"  [ngStyle]="!isLogged ? { 'margin-top': '300px' } : {}" >
    <img src="/assets/images/success.svg" alt="Payment completed successfully">
    <h3 [appTranslate]="'PAYMENT_SUCCESS'"></h3>
<!-- 
    <div >
        <button type="button" class="btn btn-next" (click)="goToDashboard()" [appTranslate]="'REQUIREMENTS'" aria-label="Go to requirements"></button>
    </div> -->
</div>